import {
  getMyInboxRoutes,
  getNotificationsPageRoutes,
  getProfilesRoutes,
} from "@/router/general/pages";
import Route from "@/entities/Route";

export const generalRoutes: Route[] = [
  ...getMyInboxRoutes({}),
  ...getProfilesRoutes({}),
  ...getNotificationsPageRoutes({}),
];
